import React from 'react';

/** Содержимое tooltip для списка победителей — каждое имя на отдельной строке.
 *  Native title=text.join('\n') игнорирует переносы в большинстве OS, отсюда отдельный helper.
 *  В отдельном модуле (не в WinnerNamesChip) ради react-refresh/only-export-components. */
export const renderWinnersTooltipContent = (names: string[]): React.ReactNode => (
    <div>
        {names.map((n, i) => (
            <div key={`${i}-${n}`}>{n}</div>
        ))}
    </div>
);
